import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import * as moment from "moment";
import _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskProvider } from '../../providers/task/task';
import { AlertController, LoadingController } from 'ionic-angular';
import { UtilityProvider } from '../../providers/utility/utility';

@Component({
  selector: 'patient-tasks',
  templateUrl: 'patient-tasks.html'
})
export class PatientTasksComponent implements OnInit  {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  patient: any;
  exportjson: any;
  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  userid: string;
  user_fullname: string;
  user: any;
  taskPanelStatus = false;
  existing = false;
  task_id: string;

  tasks: any[] = [];
  tasks_completed: any[] = [];
  task_types: any[] = [];
  priority: string;
  cms: any[] = [];
  ncms: any[] = [];

  addeditForm: FormGroup; 

  displayedColumns = ['checkbox', 'type', 'priority', 'due_date', 'assigneduser', 'program_patient_id', 'last_name', 'notes', 'actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('formDirective') private formDirective: NgForm;

  constructor(
    private readonly auth: AuthProvider,
    private db: DatabaseProvider,
    private dbTask: TaskProvider,
    private fb: FormBuilder,
    public alertCtrl: AlertController,
    public utility: UtilityProvider,
    public loadingCtrl: LoadingController
    ) {
  
    this.createForm();
  
    this.auth.getCurrentUser().then(user => {
      this.userid = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };

      this.dbTask
      .listTasksByPatient(this.program_id, this.patient.id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe(tasks => {
        const t = tasks.filter(task => {
          if (task.priority === 0 || task.priority === '0') {
            task.priority = 'Urgent';
          } else if  (task.priority === 1 || task.priority === '1') {
            task.priority = 'High';
          } else if  (task.priority === 2 || task.priority === '2') {
            task.priority = 'Medium';
          } else {
            task.priority = 'Low';
          }
        });
        this.tasks = tasks.sort(task => !task.completed ? -1 : 1);
        this.exportjson = this.tasks;
        this.dataSource = new MatTableDataSource(this.tasks);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });

      this.db
      .getUsers()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((users) => {
        this.cms = _.filter(users, user => user.roles.navigator_ncm || user.roles.navigator_rcm);
      });

      this.db
      .getAdminSettings(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((settings) => {
        this.task_types = settings[1]['types'];
      });
    
    // Preset Fields
    this.priority = '2';
    });
  }

  ngOnInit()  {
    this._program_id
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Program ID on Summary: ', x)
        this.program_id = x
    });

    this._program_name
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Program Name on Summary: ', x)
        this.program_name = x
    });

    this._patient
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Patient on Summary: ', x)
        this.patient = x
    });
  }

  ngOnDestroy() {
    console.log('Leave patient tasks and destroy subscriptions');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  cancel()  {
    this.taskPanelStatus = false;
    setTimeout(() => {
      this.existing = false;
      this.formDirective.resetForm();
      this.addeditForm.reset();
    }, 0);
  }


  edit(item) {
    this.task_id = item.id;
    let new_item = {
      case_manager: null,
      type: item.type,
      priority: null,
      due_date: new Date(item.due_date.seconds * 1000),
      notes: item.notes
    }
    const cm =  this.cms.filter(x => x.id === item.assigneduser_id);
    if(cm) {
      new_item.case_manager = cm[0];
    }
    if(item.priority === 'Urgent') {
      new_item.priority = '0';
    } else if (item.priority === 'High') {
      new_item.priority = '1';
    } else if (item.priority === 'Medium') {
      new_item.priority = '2';
    } else {
      new_item.priority = '3';
    }

    this.addeditForm.patchValue(new_item);
    this.taskPanelStatus = true;
    this.existing = true;
  }
  
  delete(item){
      let confirm = this.alertCtrl.create({
        title: "Delete Task",
        message: "Are you sure you want to delete this task?  If so, type 'delete' into the textbox to confirm",
        inputs: [
          {
            name: 'delete_text',
            placeholder: 'delete',
            type: 'text'
          }
        ],
        buttons: [
          {
            text: "Cancel",
            handler: () => {
              // console.log("Don't update");
            }
          },
          {
            text: "Delete Task",
            handler: data => {
              let delete_text = data.delete_text;
              if(delete_text === 'delete') {
            
                this.dbTask.deleteTask(this.program_id, this.patient.id, item.id)
                .then(response => {
                  this.utility.presentToast('The task was successfully deleted');
                })
                .catch(err => {
                  this.utility.presentToast('The task could not be deleted');
                });
              } else {
                return;
              }
            }
          }
        ]
      });
      confirm.present();
      }


  save()  {
    const loading = this.loadingCtrl.create({});
    loading.present();
    let task = this.addeditForm.value;
    task.priority = parseInt(task.priority);
    const patient = {
      id: this.patient.id,
      first_name: this.patient.first_name,
      last_name: this.patient.last_name,
      program_patient_id: this.patient.program_patient_id
    }
    task = { assigneduser_id: task.case_manager.id, assigneduser: task.case_manager.first_name + ' ' + task.case_manager.last_name, ...task, patient: patient };
    delete task.case_manager;
    if (!this.existing) {
      // Add Task
      this.dbTask.addTask(this.program_id, this.patient.id, task, this.user)
      .then(() => {
        this.cancel();
        loading.dismiss();
        this.addeditForm.controls['priority'].setValue('2');
        this.utility.presentToast('The task was succesfully added.')
      })
      .catch(err => {
        loading.dismiss();
        this.utility.presentToast('The task could not be saved.  Please try again.')
      })
    } else {
      // Edit Task
      this.dbTask.updateTask(this.program_id, this.patient.id, this.task_id, task, this.user)
      .then(() => {
        this.task_id = null;
        this.cancel();
        loading.dismiss();
        this.addeditForm.controls['priority'].setValue('2');
        this.utility.presentToast('The task was succesfully updated.')
      })
      .catch(err => {
        loading.dismiss();
        this.utility.presentToast('The task could not be saved.  Please try again.')
      })
    }
  }


  createForm()  {
    this.addeditForm = this.fb.group({
      'case_manager': [null, [Validators.required]],
      'type': [null, [Validators.required]],
      'priority': [null, [Validators.required]],
      'due_date': [null, [Validators.required]],
      'notes': [null]
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  exportTasks() {
    let task_download = [];
    this.tasks.filter(task => {
      const newtask = { 
        'Type': task.type,
        'Priority': task.priority,
        'Due Date': task.due_date ? task.due_date.toDate() : null,
        'Assign To': task.assigneduser, 
        'Assign By': task.createdBy.name,
        'Assigned Date': task.createdAt ? task.createdAt.toDate() : null,
        'Patient Name': task.patient ? task.patient.first_name + ' ' + task.patient.last_name : null,
        'Patient ID': task.patient.program_patient_id,
        'Notes': task.notes ? task.notes : null,
        'Completed': task.completed,
        'Completed Date': task.task_completed_date ? task.task_completed_date.toDate() : null
      }
      task_download.push(newtask)
    });

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(task_download);
    workSheet['!autofilter'] = { ref: "A1:K1" };
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Tasks'); // add the worksheet to the book
    XLSX.writeFile(workBook, moment().format('YYYY-MMM-DD-HHssA') + '-tasks.xlsx'); // initiate a file download in browser
  }

  onSelect(ev, cell, row) {
    if(ev.checked)  {

    let alert = this.alertCtrl.create({
      title: 'Task Complete?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: data => {
            // console.log('Cancel clicked');
            ev.checked = false;
          }
        },
        {
          text: 'Yes',
          handler: data => {
            // console.log('note: ', data.note);
            // console.log(ev, cell, row);
            let note = '';
            this.db.updateTask(this.program_id, this.userid, this.user_fullname, row.patient.id, row.id, note).then(() => {
              ev.checked = false;
            });
          }
        }
      ]
    });
    alert.present();
          
  }
  }
  

}



// WEBPACK FOOTER //
// ./src/components/patient-tasks/patient-tasks.ts